import { type I18nLocale, t } from '@ardoq/i18n';

export type LoadingMessageKey = 'hierarchy' | 'query';
export type LoadErrorMessageKey = 'hierarchy' | 'query';

const loadingMessages: Record<LoadingMessageKey, [string, string]> = {
  hierarchy: [
    'componentHierarchies:navigator.loading.hierarchy',
    'Loading ...',
  ],
  query: ['componentHierarchies:navigator.loading.query', 'Loading query ...'],
};

export const translateLoadingMessage = (
  i18nLocale: I18nLocale,
  key: LoadingMessageKey
): string => {
  const [i18nKey, fallback] = loadingMessages[key];
  return t(i18nLocale, i18nKey, fallback);
};

const loadErrorMessages: Record<LoadErrorMessageKey, [string, string]> = {
  hierarchy: [
    'componentHierarchies:navigator.loadError.hierarchy',
    "Sorry, we couldn't load the workspace hierarchy",
  ],
  query: [
    'componentHierarchies:navigator.loadError.query',
    "Sorry, we couldn't load the query",
  ],
};

export const translateLoadErrorMessage = (
  i18nLocale: I18nLocale,
  key: LoadErrorMessageKey
): string => {
  const [i18nKey, fallback] = loadErrorMessages[key];
  return t(i18nLocale, i18nKey, fallback);
};
